export default {
    addressSearching: 'address_searching',
    loginWithEmail: 'login_with_email',
    loginWithPhone: 'login_with_phone',
    signup: 'signup',
    checkGiftCardBalance: 'check_gift_card_balance',
    loginWithFacebook: 'login_with_facebook',
    addDiscount: 'add_discount'
};
